<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search name or email"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No access requests found..."/>

      <b-table
        v-if="data.length"
        ref="table"
        :responsive="true"
        :busy="fetching"
        :items="data"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged">

        <template slot="user" slot-scope="data">
          <span class="name">{{ data.value.name }}</span>
          <span>{{ data.value.email }}</span>
          <b-badge v-if="!data.value.is_active" variant="danger">Account Locked</b-badge>
          <b-badge v-if="!data.value.is_confirmed" variant="danger">Not Confirmed</b-badge>
        </template>

        <template slot="requested" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div v-if="view === 'pending'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="approve">
              <b-button
                :disabled="fetching"
                title="approve"
                variant="outline-secondary"
                @click="approve(data.item.id)">
                <i class="fas fa-thumbs-up"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="decline">
              <b-button
                :disabled="fetching"
                title="decline"
                variant="outline-secondary"
                @click="decline(data.item.id)">
                <i class="fas fa-thumbs-down"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="archive">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click="archive(data.item.id)">
                <i class="fas fa-archive"></i>
              </b-button>
            </span>
          </div>
          <div v-if="view === 'declined'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="approve">
              <b-button
                :disabled="fetching"
                title="approve"
                variant="outline-secondary"
                @click="approve(data.item.id)">
                <i class="fas fa-thumbs-up"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="archive">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click="archive(data.item.id)">
                <i class="fas fa-archive"></i>
              </b-button>
            </span>
          </div>
          <div v-if="view === 'archived'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="restore">
              <b-button
                :disabled="fetching"
                variant="outline-secondary"
                @click="restore(data.item.id)">
                <i class="fas fa-check"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'

export default {
  mixins: [tableMixin],
  data () {
    return {
      formFields: [
        { key: 'user', label: 'From', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'requested', label: 'Requested', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      namespace: 'accessRequests'
    }
  },
  methods: {
    approve (id) {
      this.$store.dispatch('accessRequests/approve', id)
    },
    decline (id) {
      this.$store.dispatch('accessRequests/decline', id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/access-requests/table.vue